{
  "table": {
    "titleJ": "VOLI ALIANTE",
    "titleM": "VOLI A MOTORE"
  },
  "modal": {
    "zapis": "Record modificato da:",
    "namen": "Scopo:",
    "naloga": "Compito:",
    "reg": "Registrazione:",
    "pilot": "Pilota:",
    "krajV": "Luogo di decollo:",
    "krajP": "Luogo di atterraggio:",
    "vZraku": "in volo:",
    "vizuelno": "visivo:",
    "stPristankov": "Numero di atterraggi:",
    "opomba": "Nota:",
    "datumU": "Data modifica:",
    "regV": "Registrazione aereo da traino:",
    "instruktor": "Istruttore:",
    "poletanje": "Decollo:",
    "casO": "Ora di sgancio:",
    "pristanek": "Atterraggio:",
    "trajanje": "Durata:",
    "vleka": "Traino:",
    "casV": "Tempo di traino:"
  }
}